import { useState } from 'react';
const referenceProperties = {
  join: false,
  document: null,
  participants: false,
  documentMissing: false
};
// Para la vinculacion de nuevos documentos con otros ya existentes
function useReferenceComponent(options = {}) {
  const [reference, setReference] = useState({ ...referenceProperties, ...options });
  const handleReferenceChange = (data) => {
    setReference({ ...reference, ...data });
  };

  return [reference, handleReferenceChange];
}

export default useReferenceComponent;
